<script lang="ts">
  import { useWallet } from '@do/svelte-web3-manager';

  import { BurgerButton } from '@shared/ui/buttons/burger';
  import { Sidebar } from '@shared/ui/sidebar';
  import { is } from '@shared/utils';

  import { ConnectedWallet } from '@entities/wallet';

  import Connected from './connected.svelte';
  import { walletSidebarActivity } from '../model';
  import Footer from './footer.svelte';
  import Unconnected from './unconnected.svelte';

  const wallet = useWallet();
</script>

<Sidebar sidebarActivity="{$walletSidebarActivity}" handleClose="{() => walletSidebarActivity.close()}">
  <div class="no-scrollbar flex h-full flex-col justify-between overflow-auto">
    <div class="px-6 pb-6">
      <div class="flex justify-between gap-2">
        <div class="flex flex-wrap items-end gap-4 py-4">
          <p class="text-2xl font-semibold">{is($wallet, 'Your wallet', 'Connect your wallet')}</p>
          {#if $wallet}
            <div>
              <ConnectedWallet />
            </div>
          {/if}
        </div>

        <div class="flex items-start pt-6 md:hidden">
          <BurgerButton isActive on:click="{() => walletSidebarActivity.close()}" />
        </div>
      </div>

      {#if $wallet}
        <Connected />
      {:else}
        <Unconnected />
      {/if}
    </div>

    <Footer />
  </div>
</Sidebar>
